import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Header, Paper, Title } from '../../components';

import Form from './loyaltyProgram.form';

import { config } from '../../api/config';
import { actions } from '../../state';

import {
  loyaltyProgramFormDefaultValues,
  mapGoalToApiPayload,
} from './loyaltyProgram.data';

const AddLoyaltyProgram = ({ dispatch, history }) => {
  const addLoyaltyProgramAction = useCallback(
    body => {
      dispatch(
        actions.loyaltyProgram.addLoyaltyProgramAction({ ...body }, history)
      );
    },
    [dispatch, history]
  );

  const onSubmit = useCallback(
    data => {
      const goals = data.goals.map(goal => mapGoalToApiPayload(goal));

      addLoyaltyProgramAction({ ...data, goals });
    },
    [addLoyaltyProgramAction]
  );

  return (
    <section>
      <Header size="sm">
        <Title>{config.PAGES.addLoyaltyProgram}</Title>
      </Header>

      <Paper size="sm">
        <Form
          defaultValues={loyaltyProgramFormDefaultValues}
          onSubmit={onSubmit}
          isEdit={false}
        />
      </Paper>
    </section>
  );
};

const mapStateToProps = state => ({
  loyaltyProgram: state.loyaltyProgram,
});

AddLoyaltyProgram.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps)(AddLoyaltyProgram);
